export default "__VITE_ASSET__Cr_qLA3P__"